export default "__VITE_ASSET__C653vM6G__"